import { default as auth } from "./auth"
import { default as common } from "./common"
import { default as performanceManagement } from "./performance-management"
import { default as productManagement } from "./product-management"
import { default as route } from "./route"
import { default as signage } from "./signage"
import { default as storeManagement } from "./storeManagement"
import { default as tag } from "./tag"
import { default as userManagement } from "./user-management"
import { default as workManagement } from "./work-management"
import { default as workerManagement } from "./worker-management"

export default {
  auth,
  common,
  workManagement,
  productManagement,
  workerManagement,
  userManagement,
  performanceManagement,
  route,
  signage,
  storeManagement,
  tag,
}
